import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { getSearchParam } from 'utils/params';

const Body = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let meetingId = getSearchParam('meetingId');

    if (!meetingId) {
        const match = window.location.pathname.match(/\/presentation\/([^/]+)/);
        if (match && match[1]) {
            meetingId = match[1];
        }
       const parts = window.location.pathname.split('/');
       const potentialId = parts[parts.length - 1];
        if (potentialId && potentialId.match(/^[a-z0-9]{40}-[0-9]{13}$/)) {
            meetingId = potentialId;
        }
    }
    
    // Sanity check, though button shouldn't appear if no meetingId/file
    if (!meetingId) {
      setLoading(false);
      setError(true);
      return;
    }

    const url = `/presentation/${meetingId}-summary/summary.md`;

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then((text) => {
        setContent(text);
        setLoading(false);
      })
      .catch((e) => {
        console.error('Failed to fetch summary:', e);
        setError(true);
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="modal-body">Loading...</div>;
  if (error) return <div className="modal-body">Failed to load summary.</div>;

  return (
    <div className="modal-body">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
    </div>
  );
};

export default Body;
